<template>
  <div class="ap-footer">
    <div />
    <b-nav>
      <b-nav-item
        id="vtFooterPrint"
        class="itemfooter"
      >
        <div
          v-if="printService"
          v-tooltip="$t('printService.on')"
          class="circle"
        >
          <i
            class="fas fa-print"
            aria-hidden="true"
          />
        </div>
        <div
          v-if="!printService"
          v-tooltip="$t('printService.off')"
          v-b-modal="'modal-print'"
          class="circle-no"
        >
          <i
            class="fas fa-print"
            aria-hidden="true"
          />
        </div>
      </b-nav-item>
      <b-nav-item
        v-if="false"
        id="vtFooterVersion"
        class="itemfooter nolink"
      >
        {{ $t('global.codeVersion') }} {{ version }}
      </b-nav-item>
      <b-nav-item
        id="vtFooterContact"
        href="http://www.vitro.bio/"
        target="_blank"
        class="itemfooter picture nolink"
      >
        <b-button
          id="popover-vitro"
          variant="primary"
          class="simple-pop mr-3"
        >
          <img
            src="../../img/vitro-logo-color.png"
            alt="vitro-logo"
          >
        </b-button>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'VtFooter',
    data() {
        return {
            show: false
        }
    },
    computed: {
        printService() {
            return this.$store.getters.printServiceStatus
        },
        getCurrentYear() {
            return moment().format('YYYY')
        },
        version() {
            return this.$store.getters.parameters.global?.releaseVersion
        }
    }
}
</script>
